import { Tab, Tabs } from "@mui/material";
import clsx from "clsx";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { STATUS_TABS } from "../../data";
import { selectActiveStatusTab } from "../../redux/selector";
import { actions } from "../../redux/slice";
import { useStyles } from "./styles";

const StatusTabs = () => {
  const { t, i18n } = useTranslation();
  const styles = useStyles();
  const dispatch = useDispatch();
  const activeStatusTab = useSelector(selectActiveStatusTab);
  const isEnglish = i18n.language === "en";

  return (
    <Tabs
      className={clsx(styles.tabs, isEnglish && styles.tabsScrollable)}
      value={activeStatusTab}
      onChange={(_, nextValue) =>
        dispatch(actions.setActiveStatusTab(nextValue))
      }
      variant={isEnglish ? "scrollable" : "fullWidth"}
      scrollButtons={false}
      dir={i18n.dir()}
    >
      {STATUS_TABS.map((tab, index) => (
        <Tab key={tab.id} label={t(tab.labelKey)} value={index} />
      ))}
    </Tabs>
  );
};

export default StatusTabs;
